import { render, staticRenderFns } from "./ba-textarea.vue?vue&type=template&id=13ac07fe&scoped=true&"
import script from "./ba-textarea.vue?vue&type=script&lang=js&"
export * from "./ba-textarea.vue?vue&type=script&lang=js&"
import style0 from "./ba-textarea.vue?vue&type=style&index=0&id=13ac07fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac07fe",
  null
  
)

export default component.exports